import { useCallback, useMemo, useState, type ReactNode } from "react";
import {
  NavToolbarSlotsContext,
  NavToolbarPublisherContext,
  type NavToolbarSlots,
} from "#nav-toolbar-slots-context";
/** Focused card screens contribute controls to Learn's single header row. */
export function NavToolbarProvider({ children }: { children: ReactNode }) {
  const [entries, setEntries] = useState<Map<symbol, NavToolbarSlots>>(() => new Map());
  const publish = useCallback((slots: NavToolbarSlots) => {
    const key = Symbol();
    setEntries((current) => new Map(current).set(key, slots));
    return () =>
      setEntries((current) => {
        const next = new Map(current);
        next.delete(key);
        return next;
      });
  }, []);
  const current = useMemo(() => [...entries.values()].at(-1) ?? null, [entries]);
  return (
    <NavToolbarPublisherContext value={publish}>
      <NavToolbarSlotsContext value={current}>{children}</NavToolbarSlotsContext>
    </NavToolbarPublisherContext>
  );
}
